export default __webpack_public_path__ + "static/media/english-to-norwegian-logo.7bb26c27.png";